import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  queryPayment: (param) => { // 重新支付列表
    return GET("/backend/orderDetail/queryMultiplePayments", param);
  },
  updatePayment: (param) => { // 重新支付-操作
    return POST("/backend/orderDetail/updateMultiplePayments", param);
  },
  multipleExport: (param, rsType) => {   // 重新支付导出
    return GETPDF('/backend/orderDetail/queryMultiplePaymentsExport', param, rsType);
  },
  aliInfoList: (param) => { // 记账本信息列表
    return GET("/backend/accountAli/accountAliInfoList", param);
  },
  accountExport: (param, rsType) => {   // 支付宝记账本导出
    return GETPDF('/backend/accountAli/accountAliInfoExport', param, rsType);
  },
  paymentChannel: (param) => { // 获取可新增渠道列表
    return GET("/backend/config/pay/paymentChannel", param);
  },
  listPayConfig: (param) => { // 获取支付配置列表
    return GET("/backend/config/pay/listPaySettingConfig", param);
  },
  initPayConfig: (param) => { // 新增或修改支付配置
    return POST("/backend/config/pay/initPaySettingConfig", param);
  },
  initPayDelete: (param) => { // 支付配置删除
    return GET("/backend/dataDict/delete", param);
  },
  getPayConfig: (param) => { // 获取支付配置
    return GET("/backend/config/pay/getPaySettingConfig", param);
  },
  updateConfig: (param) => { // 新增ISV配置
    return POST("/backend/config/pay/updateAliPayConfig", param);
  },
  listAliPayConfig: (param) => { // 新增ISV配置列表
    return GET("/backend/config/pay/listAliPayConfig", param);
  },
  serviceAuthorize: (param) => { // 新增服务商配置信息
    return POST("/backend/config/pay/serviceAuthorize", param);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/bookKeeping.js